const BASE_PATH = "COMPANY";
export const SET_COMPANY_AVATAR = `${BASE_PATH}/SET_COMPANY_AVATAR`;

export const setAvatar = avatar => ({
    type: SET_COMPANY_AVATAR,
    avatar
});

const initialState = {
    avatar: ""
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_COMPANY_AVATAR:
            return { ...state, avatar: action.avatar };
    }

    return state;
}